module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAABQCAYAAAD/aZ4zAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAEOSURBVFhH7ZLBDYJAEEUpxB60CT1bipxNbEBv1KAleLEFupAGDIkXSVY/ZhLc+RtlBRJlDi8bYObtzzDJrarct/yA5HrauDKbucs6qU88szpAJWU2rZt9IGP1SoIbmUBgiZQklEJgaZSENfr4PRFJpi/1oJ+ZgPDf0SkAlQDcKDKcLIEQlAjnoqDvm7yVfMLYJJ0MNs9z+r7J2CS2sXEMM1jbWI1tbBzDDNY2VmMbG8cwg7WN1djGxjHMYG1jNX+ysfvd0aWLrVtO0vo8PJ5ZHaCS1fzZ7AMZq1cSJGACAd/9HiUJpRBYGiVhjT5+T+sk+O739DMTEErDUgAqAbhRZDhZAiEoaYNJNB1IKncH/u8FvT3emNwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wl_01.png
// module id = n0Ki
// module chunks = 1